// extracted by mini-css-extract-plugin
export default {"fileList":"file_fileList__XjXcc","fileUpload":"file_fileUpload__FSnug","dragOver":"file_dragOver__pFb9Q","fileUploadBox":"file_fileUploadBox__nQ8Go"};